import { REDUX_ACTIONS, GAME_ID, TABS } from 'a/directorsCut/data/constants';

const initState = {
  activeTab: TABS.CHARACTERS, // tab (character, sceneProps, motivations)
  currentCharacterTabId: '', // which character is currently displaying on character tab
  propsScrollIndex: 0,
  emotionsScrollIndex: 0,
  isTabsAreaCollapsed: false,
  isActionButtonHidden: false,
  isArrowHintVisible: {
    [TABS.CHARACTERS]: false,
    [TABS.PROPS]: false,
    [TABS.EMOTIONS]: false,
  },
  visitedCharacters: [],
};

const tabsReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: payload,
      };

    case REDUX_ACTIONS.SET_CHARACTER_TAB_ID:
      return {
        ...state,
        currentCharacterTabId: payload,
        visitedCharacters: [
          ...state.visitedCharacters,
          payload,
        ],
      };

    case REDUX_ACTIONS.SET_PROPS_SCROLL_INDEX:
      return {
        ...state,
        propsScrollIndex: payload,
      };

    case REDUX_ACTIONS.SET_EMOTIONS_SCROLL_INDEX:
      return {
        ...state,
        emotionsScrollIndex: payload,
      };

    case REDUX_ACTIONS.SET_IS_TABS_AREA_COLLAPSED:
      return {
        ...state,
        isTabsAreaCollapsed: payload,
      };

    case REDUX_ACTIONS.SET_IS_ACTION_BUTTON_HIDDEN:
      return {
        ...state,
        isActionButtonHidden: payload,
      };

    case REDUX_ACTIONS.NEXT_STANDARD_ITEM:
      return {
        ...initState,
        currentCharacterTabId: payload,
        visitedCharacters: [payload],
      };

    case REDUX_ACTIONS.INITIALIZE_ROUND: {
      const { currentCharacterTabId } = payload;
      return {
        ...initState,
        currentCharacterTabId,
        visitedCharacters: [currentCharacterTabId],
      };
    }

    case REDUX_ACTIONS.ROUND_END: {
      return {
        ...initState,
        currentCharacterTabId: state.currentCharacterTabId,
      };
    }

    case REDUX_ACTIONS.SET_CURRENT_STANDARD_ITEM_CHARACTER_TAB_ID: {
      return {
        ...initState,
        currentCharacterTabId: payload,
      };
    }

    case REDUX_ACTIONS.SET_IS_TRY_AGAIN_VISIBLE:
      return {
        ...state,
        isTabsAreaCollapsed: true,
      };

    case REDUX_ACTIONS.SHOW_HINT_ABOVE_TAB:
      return {
        ...state,
        isArrowHintVisible: {
          ...state.isArrowHintVisible,
          [payload]: true,
        },
      };

    case REDUX_ACTIONS.SET_VISITED_CHARACTER:
      return {
        ...state,
        visitedCharacters: [
          ...state.visitedCharacters,
          payload.charaterId,
        ],
      };

    default:
      return state;
  }
};

export default tabsReducer;
